module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_15.9e069371.pdf";